import * as React from 'react';

import { PromoContactModal } from './PromoDescriptionModal/PromoContactModal/PromoContactModal';
import { PromoDescriptionModal } from './PromoDescriptionModal/PromoDescriptionModal';
import { PromoItem } from './PromoItem/PromoItem';
import { IPromotions } from '../../types/villagePromotions';

interface IPromoProps {
  builderName?: string;
  logoUrl?: string;
  phone?: string;
  promo: IPromotions;
}

export function Promo({
  promo: { name, type, endDate, description, promoLogoUrl, subtitle },
  builderName,
  logoUrl,
  phone,
}: IPromoProps) {
  const [isDescriptionModalOpen, setDescriptionModalOpen] = React.useState(false);
  const [isContactModalOpen, setContactModalOpen] = React.useState(false);

  const handleOpenDescriptionModal = () => setDescriptionModalOpen(true);
  const handleOpenContactModal = () => {
    setDescriptionModalOpen(false);
    setContactModalOpen(true);
  };

  const promoSubtitle = React.useMemo(() => {
    if (subtitle) {
      return subtitle;
    }

    return endDate ? `Действует до ${endDate}` : '';
  }, [endDate, subtitle]);

  return (
    <>
      <PromoItem
        name={name}
        type={type}
        subtitle={promoSubtitle}
        icon={promoLogoUrl}
        onClick={handleOpenDescriptionModal}
      />
      <PromoDescriptionModal
        open={isDescriptionModalOpen}
        onClose={() => setDescriptionModalOpen(!isDescriptionModalOpen)}
        handleOpenContactModal={handleOpenContactModal}
        name={name}
        description={description}
        subtitle={promoSubtitle}
        promoType={type}
        builderName={builderName}
        logoUrl={logoUrl}
        phoneNumber={phone}
      />
      <PromoContactModal
        open={isContactModalOpen}
        onClose={() => setContactModalOpen(!isContactModalOpen)}
        builderName={builderName}
        logoUrl={logoUrl}
        phoneNumber={phone}
      />
    </>
  );
}
